import { LOAD_MAP, FETCH_PORTAL_TILES, CLEAR_ACTION, ADD_SUBSCRIPTION, FETCH_PORTAL_TILES_ALINGMENT } from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchPortalTilesList = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: 'portal_tiles/get_portal_tiles_list/',
    ...FETCH_PORTAL_TILES
  }
});

 // Action to post data Subscription
export const postPortalTilesList = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `portal_tiles/${id}/subscribe_to_tile/`,
    ...ADD_SUBSCRIPTION
  }
});
export const clear = () => ({
  type: CLEAR_ACTION
});

export const fetchPortalTilesAlingment = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: 'portal_tiles/get_portal_tiles_alignment/',
    ...FETCH_PORTAL_TILES_ALINGMENT
  }
});

export const fetchSurfaces = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/surface_shapes/',
    ...LOAD_MAP
  }
});
